import React, { useState } from 'react';
import CoffeeCardWeb from './CoffeeCardWeb';
import AddCoffeeForm from './AddCoffeeForm';

interface CoffeeCardContainerProps {
    coffeeData: any[];
    onDelete?: (id: string) => void;
    showDeleteButtons?: boolean;
    onCoffeeAdded?: () => void;
}

const CoffeeCardContainer: React.FC<CoffeeCardContainerProps> = ({
    coffeeData,
    onDelete,
    showDeleteButtons = false,
    onCoffeeAdded,
}) => {
    const [showAddForm, setShowAddForm] = useState(false);
    const [expandedCardId, setExpandedCardId] = useState<string | null>(null);

    const handleCloseForm = () => setShowAddForm(false);

    // AddCoffeeForm now auto-dismisses ~2s after success via the submission hook;
    // we just hide the form here and ask the parent for a soft list refetch instead of
    // forcing a full page reload (which discarded scroll/state).
    const handleAddSuccess = () => {
        setShowAddForm(false);
        onCoffeeAdded?.();
    };

    return (
        <>
            <div className='coffee-cards-grid'>
                {coffeeData.map((coffee) => (
                    <CoffeeCardWeb
                        key={coffee._id}
                        coffeeData={coffee}
                        onDelete={onDelete ? () => onDelete(coffee._id) : undefined}
                        showDeleteButtons={showDeleteButtons}
                        expandedCardId={expandedCardId}
                        onExpandChange={setExpandedCardId}
                    />
                ))}
            </div>

            {showAddForm && (
                <AddCoffeeForm onClose={handleCloseForm} onSuccess={handleAddSuccess} />
            )}
        </>
    );
};

export default CoffeeCardContainer;
export { AddCoffeeForm };
